import { StaticCanvas, FabricObject } from 'fabric';
import { Polygon } from 'polygon-clipping';

import { Coords, MediaRectangle } from 'editor/src/store/design/types';

import CustomFabricGroup, { IGroupOptions } from 'editor/src/fabric/CustomFabricGroup';
import CustomFabricRect, { ICustomFabricRect } from 'editor/src/fabric/CustomFabricRect';
import { getBrowserFriendlyColor } from 'editor/src/util/color/colorUtils';

import getClipPath from 'editor/src/component/EditorArea/Spread/Page/MediaElement/getClipPath';
import getElementRect from 'editor/src/component/EditorArea/Spread/Page/MediaElement/getElementRect';
import getGroupInternalStrokeClipPath from 'editor/src/component/EditorArea/Spread/Page/MediaElement/Rectangle/getGroupInternalStrokeClipPath';
import getGroupRectangleRect from 'editor/src/component/EditorArea/Spread/Page/MediaElement/Rectangle/getGroupRectangleRect';
import rectangleElementDataToFabricProps from 'editor/src/component/EditorArea/Spread/Page/MediaElement/Rectangle/rectangleElementDataToFabricProps';
import { CanvasRotation } from 'editor/src/component/EditorArea/types';

const addRectangle = (
  fabricCanvas: StaticCanvas,
  rectangleData: MediaRectangle,
  elementIndex: number,
  pageCoords: Coords,
  clipPathPolygons: Polygon[],
  contentClipPath: FabricObject | undefined,
  mm2px: (size: number) => number,
  canvasRotation: CanvasRotation,
) => {
  const frameRect = getElementRect(rectangleData, pageCoords, canvasRotation, mm2px);
  const fabricProps = rectangleElementDataToFabricProps(rectangleData, elementIndex, mm2px);
  fabricProps.fill = fabricProps.fill ? getBrowserFriendlyColor(fabricProps.fill) : undefined;
  fabricProps.stroke = fabricProps.stroke ? getBrowserFriendlyColor(fabricProps.stroke) : undefined;
  // A strokeWidth without a stroke colour paints nothing, but fabric still grows the rect's
  // bounding box by it — and the group lays the child out by that inflated box, so the fill ends
  // up inset by strokeWidth/2 on every side. Designs do carry a strokeWidth on shapes that have no
  // stroke, and on a full-bleed shape that inset shows up as the preview being cut off.
  if (!fabricProps.stroke) {
    fabricProps.strokeWidth = 0;
  }

  const clipPath = getClipPath(frameRect, clipPathPolygons, false);

  const groupOptions: IGroupOptions = {
    ...frameRect,
    objectCaching: false,
    strokeWidth: fabricProps.strokeWidth,
    zIndex: fabricProps.zIndex,
    clipPath,
  };

  const rectOptions: ICustomFabricRect = {
    ...fabricProps,
    ...getGroupRectangleRect(frameRect, fabricProps.strokeWidth * 2),
    clipPath: getGroupInternalStrokeClipPath(frameRect, fabricProps.rx || 0),
  };

  const groupObj = new CustomFabricGroup([new CustomFabricRect(rectOptions)], groupOptions);
  fabricCanvas.add(groupObj);
};

export default addRectangle;
